import fs from 'node:fs'
import path from 'node:path'
import { PINNED_PNPM_PACKAGE_MANAGER } from '@cli-constants/tool-versions.js'
import { isSupportedPnpmPackageManager } from '@next-adapter/package-json/is-supported-pnpm-package-manager.js'
import { readProjectPackageJson } from '@next-adapter/package-json/read-project-package-json.js'
import { hasSupportedAncestorPnpmPackageManager } from './has-supported-ancestor-pnpm-package-manager.js'

export function ensurePnpmPackageManager(cwd: string): void {
  const pkgPath = path.join(cwd, 'package.json')
  const pkg = readProjectPackageJson(cwd)
  if (!pkg) {
    return
  }

  const currentPackageManager = pkg.packageManager
  if (currentPackageManager) {
    if (isSupportedPnpmPackageManager(currentPackageManager)) {
      return
    }
  } else if (hasSupportedAncestorPnpmPackageManager(cwd)) {
    return
  }

  pkg.packageManager = PINNED_PNPM_PACKAGE_MANAGER
  fs.writeFileSync(pkgPath, `${JSON.stringify(pkg, null, 2)}\n`, 'utf-8')
}
